export default () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 1L5 5L1 1" stroke="currentColor" stroke-width="1.5" />
  </svg>
);
